export default class CanvasAnimation {
    private canvas: HTMLCanvasElement;
    private ctx: CanvasRenderingContext2D;
    private svg: SVGElement | null;

    constructor(section: HTMLElement) {
        this.canvas = document.querySelector("#hero-image") as HTMLCanvasElement;
        this.ctx = this.canvas.getContext("2d") as CanvasRenderingContext2D;
        this.svg = document.querySelector(".main-image svg");

        this.init();
    }

    public init = async (): Promise<void> => {
        // const xml = new XMLSerializer().serializeToString(this.svg);
        // const svg64 = btoa(xml);
        // const b64Start = "data:image/svg+xml;base64,";
        // const image64 = b64Start + svg64;
        // const img = new Image();
        // img.onload = () => {
        //     this.ctx.drawImage(img, 0, 0);
        //     // animate the SVG elements here using CanvasRenderingContext2D methods
        // };
        // img.src = image64;
    };
}
